import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ChartService {
constructor(private http: HttpClient) { }
  httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
    })
  };
  version = 'v1.0';
  //Số lượng tỉnh thành phố
  urlGetPieChartByProvinces = environment.apiUrl + this.version + '/RpPieChart/GetPieChartByProvinces';
  //Số lượng cơ sở 
  urlGetPieChartByTypeOfEducation = environment.apiUrl + this.version + '/RpPieChart/GetPieChartByTypeOfEducation';
  //khuyết số lượng dạng khuyết tật
  urlGetPieChartTypeOfDisbility = environment.apiUrl + this.version + '/RpPieChart/GetPieChartTypeOfDisbility';
  //Thống kê theo cấp đào tạo
  urlGetRpQuantitySchoolLevel = environment.apiUrl + this.version + '/RpPieChart/GetRpQuantitySchoolLevel';
  //Thống kê nhân sự
  urlQuantityTypeOfPersonnel = environment.apiUrl + this.version + '/RpPieChart/RpQuantityTypeOfPersonnel';
  //Thống kê theo độ tuổi nhân sự
  urlGetRpQuantityAgeStaff = environment.apiUrl + this.version + '/RpPieChart/GetRpQuantityAgeStaff';
  //Thống kê theo tuổi học sinh
  urlGetRpQuantityAgeStudent = environment.apiUrl + this.version + '/RpPieChart/GetRpQuantityAgeStudent';
  GetPieChartByProvinces(): Observable<any>{
    return this.http.get(this.urlGetPieChartByProvinces,this.httpOptions);
  }
  GetPieChartTypeOfDisbility(): Observable<any>{
    return this.http.get(this.urlGetPieChartTypeOfDisbility,this.httpOptions);
  }
  GetPieChartByTypeOfEducation(): Observable<any>{
    return this.http.get(this.urlGetPieChartByTypeOfEducation,this.httpOptions);
  }
  GetRpQuantitySchoolLevel(): Observable<any>{
    return this.http.get(this.urlGetRpQuantitySchoolLevel,this.httpOptions);
  }
  GetRpQuantityTypeOfPersonnel(): Observable<any>{
    return this.http.get(this.urlQuantityTypeOfPersonnel,this.httpOptions);
  }
  GetGetRpQuantityAgeStaff(): Observable<any>{
    return this.http.get(this.urlGetRpQuantityAgeStaff,this.httpOptions);
  }
  GetRpQuantityAgeStudent(): Observable<any>{
    return this.http.get(this.urlGetRpQuantityAgeStudent,this.httpOptions);
  }
}
